import { MenuModel } from '@bo-client/core/navigation/menu.model';

export enum UserMenuActionEnum {
  changeProfile = 'changeProfile',
  changePassword = 'changePassword',
  logout = 'logout',
  changePersonalization = 'changePersonalization'
}

export const UserMenu: MenuModel[] = [
  {
    label: 'Passwort ändern',
    icon: 'key',
    action: UserMenuActionEnum.changePassword,
    roles: ['ALL_USERS']
  },
  {
    label: 'Profil bearbeiten',
    icon: 'person_edit',
    action: UserMenuActionEnum.changeProfile,
    roles: ['ALL_USERS']
  },
  {
    label: 'Personalisierung anpassen',
    icon: 'brush',
    action: UserMenuActionEnum.changePersonalization,
    roles: ['ALL_USERS']
  },
  {
    label: 'Logout',
    icon: 'logout',
    action: UserMenuActionEnum.logout,
    roles: ['ALL_USERS']
  }
];
